import React from 'react';
export function ProblemSection() {
  return <section className="bg-sage/10 py-20 px-4 border-y border-sage/20" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-130">
          <div className="space-y-6" data-id="element-131">
            <h2 className="text-3xl md:text-4xl text-near-black" data-id="element-132">
              El "Vientre de Cortisol"
            </h2>
            <p className="text-lg font-sans text-gray-700 leading-relaxed" data-id="element-133">
              Vives en un estado de alerta constante. El café en ayunas, las
              notificaciones del móvil y las comidas rápidas frente al ordenador
              han convencido a tu cerebro de que estás en peligro.
            </p>
            <p className="text-lg font-sans text-gray-700 leading-relaxed" data-id="element-134">
              El resultado es una inflamación rígida que no desaparece con
              abdominales. Te sientes pesado, tu mente está nublada y llegas al
              final del día con los tobillos marcados por los calcetines.
            </p>
          </div>
          <div className="bg-white p-8 shadow-sm border border-sage/30" data-id="element-135">
            <h3 className="text-xl font-serif text-dark-green mb-4" data-id="element-136">
              El ciclo del bloqueo:
            </h3>
            <ul className="space-y-4 font-sans text-gray-600" data-id="element-137">
              <li className="flex items-start" data-id="element-138">
                <span className="text-sage mr-3 mt-1" data-id="element-139">01.</span>
                <span data-id="element-140">Estrés crónico eleva el cortisol.</span>
              </li>
              <li className="flex items-start" data-id="element-141">
                <span className="text-sage mr-3 mt-1" data-id="element-142">02.</span>
                <span data-id="element-143">El cuerpo retiene sodio y agua por supervivencia.</span>
              </li>
              <li className="flex items-start" data-id="element-144">
                <span className="text-sage mr-3 mt-1" data-id="element-145">03.</span>
                <span data-id="element-146">Tu sistema de drenaje natural se bloquea.</span>
              </li>
              <li className="flex items-start" data-id="element-147">
                <span className="text-sage mr-3 mt-1" data-id="element-148">04.</span>
                <span data-id="element-149">La inflamación se vuelve tu estado base.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}